export default {
    url: '/courses',
    template: `
        <div class="col00" ng-if="vm.PrivilegeService.canViewCourses()">
            <ui-view></ui-view>
        </div>
    `,
    abstract: true,
    data: {
        canAccess: (AuthService, PrivilegeService) => {
            return PrivilegeService.canViewCourses();
        }
    },
    controller ($state, PrivilegeService) {
        this.$state = $state;
        this.PrivilegeService = PrivilegeService;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/index.js